import { createContext, useContext, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useSeo } from "@/components/site/Seo";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);
  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  };
  return <AuthCtx.Provider value={{ user, setUser, logout }}>{children}</AuthCtx.Provider>;
};

export const useAuth = () => useContext(AuthCtx);

export const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  useSeo({ title: "Admin", description: "", path: "/tigasatu", noindex: true });
  if (user === null) return <div className="grid min-h-screen place-items-center bg-ink font-mono text-sm text-zinc-400">Memuat…</div>;
  if (!user) return <Navigate to="/tigasatu" replace />;
  return children;
};
